import React from "react";
import Calendar from "react-calendar";

import axiosInstance from "utils/axiosInstance";

import "react-calendar/dist/Calendar.css";
import "./styles.css";

function NotchCalendar({ 
    selectedDate, 
    setSelectedDate, 
    setNotches, 
    setDaysWithNotches, 
    daysWithNotches,
    onDateChangeAction
}) {
    // Handle date click
    const handleDateClick = async (date) => {
        const formattedDate = date.toLocaleDateString("en-CA");

        try {
            const response = await axiosInstance.get(`/api/notches/${formattedDate}`);

            setNotches(response.data.data);
            onDateChangeAction();

        } catch (error) {
            console.error("Error fetching data:", error);
        }

        setSelectedDate(formattedDate);
    };

    const handleMonthChange = async ({ activeStartDate, view }) => {
        if (view === "month") {
            const [year, month] = activeStartDate.toLocaleDateString("en-CA").split("-");

            try {
                const response = await axiosInstance.get(`/api/notches/days-with-notches?month=${Number(month)}&year=${year}`);
    
                setDaysWithNotches(response.data.data.days_with_notches);
            } catch (error) {
                console.error("Error fetching data:", error);
            }

        }
    };

    return (
        <div>
            <Calendar
                theme = {{
                    calendarBackground: "#0d6efd"
               }}
                value={selectedDate}
                onClickDay={handleDateClick}
                onActiveStartDateChange={handleMonthChange}
                tileContent={({ date, view }) =>
                    view === "month" && daysWithNotches.includes(date.toLocaleDateString("en-CA")) ? (
                        <div className="dot"></div>
                    ) : null
                }
            />
        </div>
    );
};

export default NotchCalendar;
